import { DateTime } from 'luxon'

import { withResourceRecord } from '@/shared/contexts'
import { useDigitalProductContext } from '@/shared/contexts/DigitalProductContext'
import { useResourceRecordContext } from '@/shared/hooks'
import { useModalContext } from '@/shared/hooks'
import { useUserProgress } from '@/shared/hooks/useUserProgress'
import { showErrorAlert } from '@/shared/lib/errors'
import { api } from '@/shared/lib/api'
import { Button, Card, LoadWrapper } from '@/shared/ui'
import { FormGroup, FormControl, ImageInput } from '@/shared/ui/Form'
import { QRCodeModal } from '@/shared/ui/QRCodeModal'

import { sanitizeEmbedHtml, sanitizeHtml } from '@/shared/lib/html/sanitize'
import { getConfig } from './config'
import { Screen, PageHeader } from '@/shared/ui/Layout'

export const DigitalProductLiveStreams = withResourceRecord(() => {
  const { showModal } = useModalContext()

  const { basePathWithId, getLiveStreamsProgress } = useDigitalProductContext()

  const { refetchProgress } = useUserProgress()
  const {
    record: liveStream,
    loadWrapperConfig,
    Form,
    isSubmitting,
    config: {
      apiBasePath,
      basePath,
      getStatus,
      getSubliveStreamStatus
    }
  } = useResourceRecordContext()

  return (
    <Screen>
      <Screen.Context>
        <PageHeader title={liveStream?.name || ''} backHref={basePath} />
      </Screen.Context>
      <Screen.Content>
        <LoadWrapper {...loadWrapperConfig}>
          <Card className="mb-8">
            <Card.Body>
              <div className="flex flex-col mb-6 mt-5">
                {liveStream?.kind == 'embedded' && (
                  <div
                    className="aspect-video"
                    dangerouslySetInnerHTML={{
                      __html: sanitizeEmbedHtml(liveStream?.embedded_code)
                    }}
                  ></div>
                )}
                {liveStream?.kind == 'link' && (
                  <div className="flex flex-col gap-6 p-4 bg-gray-100">
                    <span className="text-2xl block font-bold text-center">
                      Evento iniciado, acesse agora!
                    </span>
                    <Button
                      href={liveStream?.link}
                      variant="primary"
                      className="w-full"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Acessar transmissão
                    </Button>
                  </div>
                )}
              </div>
              <div
                className="text-base text-gray-700"
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(liveStream?.description) }}
              />
            </Card.Body>
          </Card>
        </LoadWrapper>
      </Screen.Content>
    </Screen>
  )
}, getConfig)
